<template>
    <div>
        <div class="w-full text-left pl-8 pt-4">* Required fields</div>
        <form @submit.prevent="update">
            <div class="p-8 pb-2 flex flex-wrap" @change="dirtyForm()" @keydown="dirtyForm">
                <!--v-if="applicationData?.programme_code === 'T' || applicationData?.programme_code === 'O'"-->
                <label 
                       class="pr-6 text-right"
                >
                    <strong>Are you applying using an LSHTM approved agent?</strong>
                </label>
                
                <!-- Yes/No Radio Buttons for isAgentChecked 
                  v-if="applicationData?.programme_code === 'T' || applicationData?.programme_code === 'O'"-->
                <div class="text-left mx-4 mt-2">
                    <div class="md:inline-block">
                        <input id="agent-yes-option"
                               v-model="isAgentChecked"
                               :value="true"
                               type="radio"
                               name="isAgentChecked"
                        />
                        <label for="agent-yes-option" class="ml-2"><strong>Yes</strong></label>
                    </div>
                    <div class="md:inline-block mx-4">
                        <input id="agent-no-option"
                               v-model="isAgentChecked"
                               :value="false"
                               type="radio"
                               name="isAgentChecked"
                               @update:modelValue="value = $event"
                        />
                        <label for="agent-no-option" class="ml-2"><strong>No</strong></label>
                    </div>
                </div>

                <div class="w-full" />

                <!-- Agent Selection -->
                <select-input v-if="isAgentChecked"
                              id="agent-select"
                              v-model="selectedAgent"
                              name="agent"
                              class="pr-12"
                              label="* Please select your agent"
                              @change="fetchAgentOffices"
                              @update:modelValue="value = $event"
                              :error="form.errors?.agent_code"
                >
                    <option v-for="agent in agents" :key="agent.reference" :value="agent.code">{{ agent.name }}</option>
                </select-input>

                <!-- Agent Office Selection -->
                <select-input v-if="isAgentChecked"
                              id="agent-office-select"
                              v-model="selectedAgentOffice"
                              name="agentOffice"
                              class="pr-12"
                              label="* Please select your agent office."
                              @update:modelValue="value = $event"
                              :error="form.errors?.agent_office_code"
                >
                    <option v-for="office in agentOffice" :key="office.id" :value="office.code">{{ office.name }}</option>
                </select-input>
                <text-input v-model="selectedAgentOfficeText" 
                            v-if="selectedAgentOfficeName == 'Other' && isAgentChecked"
                            name="agentOfficeText"
                            class="pr-12" 
                            label="* Please type your agent office details." 
                            @update:modelValue="value = $event"
                />
            </div>

            <div v-if="successMessage.length > 0" class="success-message m-8 w-auto">Agent details updated</div>
            <div v-if="validationErrors !== undefined">
                <div v-if="Object.keys(validationErrors).length > 0">
                    <p class="server-error m-8">There were some validation issues, please check the fields above</p>
                </div>
            </div>

            <div class="lg:flex justify-end w-full pb-2 -mt-8">
                <div class="relative w-auto lg:w-1/3 mx-8">
                    <div class="text-center ml-8 relative">
                        <br />
                        <button class="btn-green mb-8 w-40" type="submit">Save</button>
                        <div v-if="loading" class="lds-ring-container absolute top-2">
                            <div class="lds-ring"><div /><div /><div /><div /></div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>


<script>
import TextInput from '@/shared/TextInput'
import SelectInput from '@/shared/SelectInput'
import ApplicationComponentSaveButton from '@/shared/ApplicationComponentSaveButton'

export default {
    components: {
        TextInput,
        SelectInput,
        ApplicationComponentSaveButton,
    },
    
    props: {
        reference: String,
        applicationData: Object,
        agents: Array,
    },
    data() {
        return {
            selectedAgent: this.applicationData.agentCode,
            agentOffice: [],
            selectedAgentOffice: this.applicationData.agentOfficeCode,
            selectedAgentOfficeName: '',
            selectedAgentOfficeText: this.applicationData.agentOfficeCodeText,
            isAgentChecked: this.applicationData.noAgent === 1 ? true : false ,
            formDirty: false,
            loading: false,
            successMessage: '',
            serverErrors: '',
            form: {
                first_name: this.agentData?.first_name || '',
                last_name: this.agentData?.last_name || '',
            },
        };
    },
    mounted() {
        this.agentOffice = [];
        if (this.selectedAgent) {
            this.loading = true;
            this.$store.dispatch('fetchAgentOffices', this.selectedAgent)
                .then(offices => {
                    this.agentOffice = offices;
                    const selectedOffice = this.agentOffice.find(office => office.code === this.applicationData.agentOfficeCode);
                    this.selectedAgentOfficeName = selectedOffice ? selectedOffice.name : '';
                })
                .catch(error => {
                    console.error('Error fetching agent offices:', error);
                })
                .finally(() => {
                    this.loading = false;
                });
            if(this.applicationData.agentOfficeCode == null)
            {
                this.selectedAgentOffice = 0;
                this.selectedAgentOfficeText = this.applicationData.agentOfficeCodeText;
            }    
        }
    },
    computed: { 
        validationErrors: {
            get() {
                return this.form.errors;
            },
            set(newValue) {
                for (const key in newValue) {
                    this.form.errors[key] = newValue[key].join(' ');
                }
            },
        },
    },
    watch: {
        selectedAgentOffice(newOfficeCode) {
            const selectedOffice = this.agentOffice.find(office => office.code === newOfficeCode);
            this.selectedAgentOfficeName = selectedOffice ? selectedOffice.name : '';
        }
    },
    methods: {
        fetchAgentOffices() {
            this.selectedAgentOffice = null;
            this.agentOffice = [];
            if (this.selectedAgent) {
                this.loading = true;
                this.$store.dispatch('fetchAgentOffices', this.selectedAgent)
                    .then(offices => {
                        this.agentOffice = offices;
                    })
                    .catch(error => {
                        console.error('Error fetching agent offices:', error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        update() {

            this.loading = true;
            this.$store.dispatch('updateAgentDetails', {
                agent: this.selectedAgent,
                agentOffice: this.selectedAgentOffice,
                agentOfficeText: this.selectedAgentOfficeText,
                isAgentChecked: this.isAgentChecked,
                reference: this.reference,
            })
                .then(() => {
                    this.loading = false;
                    this.serverErrors = '';
                    this.successMessage = 'Agent details updated';
                    this.form.errors = {};
                    window.location.search += '&section=agentDetailsShow'
                })
                .catch(error => {
                    this.loading = false;
                    this.form.errors = error.response?.data?.errors || {};
                    this.validationErrors = error.response?.data?.errors || {};
                    this.successMessage = '';
                });
            this.formDirty = false;
        },
        dirtyForm() {
            this.formDirty = true;
            this.successMessage = '';
        },
    },
};
</script>
